export default __webpack_public_path__ + "static/media/pig-bronze-medal.2bef6e5f.svg";